import { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

interface DateRangePickerProps {
    startDate: Date | null;
    endDate: Date | null;
    onChange?: (dates: [Date | null, Date | null]) => void;
    dateFormat?: string;
    monthsShown?: number;
    rangeSeparator?: string;
    placeholder?: string;
}

const DateRangePicker = ({
    startDate: initialStartDate,
    endDate: initialEndDate,
    onChange: onChangeProp,
    dateFormat = 'yyyy-MM-dd',
    monthsShown = 2,
    rangeSeparator = ' ~ ',
    placeholder,
}: DateRangePickerProps) => {
    const [startDate, setStartDate] = useState<Date | null>(
        initialStartDate || null,
    );
    const [endDate, setEndDate] = useState<Date | null>(initialEndDate || null);

    const onChange = (dates: [Date | null, Date | null]) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);

        if (onChangeProp) {
            onChangeProp(dates);
        }
    };

    // 초기화 함수
    const handleReset = () => {
        setStartDate(null);
        setEndDate(null);
        if (onChangeProp) {
            onChangeProp([null, null]);
        }
    };

    return (
        <div className="datepicker-inputwraper input-group">
            <span className="input-group-text text-muted input-group-text">
                <i className="ri-calendar-line"></i>
            </span>
            <div className="react-datepicker-wrapper">
                <div className="react-datepicker__input-container">
                    <DatePicker
                        locale="ko"
                        dateFormatCalendar="yyyy년 MMMM" // 이 줄 추가!
                        selected={startDate}
                        onChange={onChange}
                        startDate={startDate}
                        endDate={endDate}
                        dateFormat={dateFormat}
                        monthsShown={monthsShown}
                        selectsRange
                        placeholderText={placeholder}
                        rangeSeparator={rangeSeparator}
                    />
                </div>
            </div>
            <span
                className="input-group-text text-muted input-group-text cursor-pointer"
                onClick={handleReset}
            >
                <i className="ri-reset-left-line"></i>
            </span>
        </div>
    );
};

export default DateRangePicker;
